module.exports = __webpack_public_path__ + "site/img/Maps_6EastTST.ddaa7f5d.jpg";